export const it = {
  paymentsTestBanner: { message: "Modalità test: i pagamenti nell'anteprima non sono reali.", learnMore: "Scopri di più" },
  nav: {
    features: "Funzionalità",
    modules: "Moduli",
    demo: "Demo",
    security: "Sicurezza",
    pricing: "Prezzi",
    faq: "FAQ",
    login: "Accedi",
    signup: "Inizia gratis",
    menu: "Menu",
    beta: "Beta aperta",
    contactSales: "Contatta vendite",
  },
  whatsappFab: {
    label: "Contatta vendite",
    aria: "Contatta vendite su WhatsApp",
  },
  heroDemo: {
    studio: "Studio",
    sections: {
      dashboard: "Dashboard",
      research: "Ricerca AI",
      analysis: "Analisi",
      drafting: "Redazione",
      matters: "Pratiche",
      calendar: "Calendario",
    },
    hint: "Demo interattiva. Clicca le voci per esplorare.",
    overview: "Panoramica",
    greeting: "Buongiorno, avvocato.",
    allGood: "Tutto in regola",
    verified: "Verificato",
    question: "Domanda",
    response: "Risposta",
    recentActivity: "Attività recenti",
    stats: {
      openMatters: "Pratiche aperte",
      deadlines7d: "Scadenze 7gg",
      researchToday: "Ricerche oggi",
      draftsReady: "Bozze pronte",
    },
    activities: {
      draftReady: "Bozza diffida pronta - Pratica Rossi",
      research: "Ricerca: prescrizione extracontrattuale",
      analysis: "Analisi contratto fornitura - 3 alert",
      reminder: "Promemoria udienza Bianchi",
      ago2m: "2 min fa",
      ago8m: "8 min fa",
      ago23m: "23 min fa",
      ago1h: "1h fa",
    },
    queries: {
      research: "Quali sono i termini di prescrizione per la responsabilità extracontrattuale?",
      analysis: "Analizza questo contratto e segnala le clausole vessatorie.",
      drafting: "Redigi una diffida per inadempimento contrattuale.",
      matters: "Mostra le pratiche con scadenze nei prossimi 7 giorni.",
      calendar: "Quali udienze ho questa settimana?",
    },
    answers: {
      research: "Ai sensi dell'art. 2947 c.c., la prescrizione ordinaria è di 5 anni dal fatto. Per fatto-reato, si applica il termine penale se più lungo.",
      analysis: "Rilevate 3 clausole vessatorie ex art. 1341 c.c.: foro esclusivo (cl. 12), limitazione di responsabilità (cl. 8), recesso unilaterale (cl. 15). Richiedono doppia sottoscrizione.",
      drafting: "Bozza pronta. La diffida richiama l'art. 1454 c.c., concede 15 giorni per l'adempimento e indica gli estremi del contratto del 12/03/2024.",
      matters: "4 pratiche in scadenza: Rossi c. Banca (memoria, 7gg), Bianchi (atto citazione, 5gg), Verdi (replica, 3gg), Neri (comparsa, 2gg).",
      calendar: "3 udienze: martedì 09:30 Trib. Milano (Rossi), giovedì 11:00 Trib. Roma (Bianchi), venerdì 14:30 CdA Torino (Verdi).",
    },
    meta: {
      researchKicker: "Ricerca legale",
      researchTitle: "Prescrizione responsabilità extracontrattuale",
      analysisKicker: "Analisi documento",
      analysisTitle: "Contratto fornitura - clausole vessatorie",
      draftingKicker: "Redazione assistita",
      draftingTitle: "Diffida ad adempiere",
      mattersKicker: "Pratiche",
      mattersTitle: "Scadenze ravvicinate",
      calendarKicker: "Agenda",
      calendarTitle: "Udienze della settimana",
    },
    chips: {
      research: [
        { t: "Cass. 12345/2024", s: "Sez. III" },
        { t: "Cass. 8821/2023", s: "Sez. Un." },
        { t: "Art. 2947 c.c.", s: "Codice civile" },
      ],
      analysis: [
        { t: "Cl. 8 - Limitazione resp.", s: "Vessatoria" },
        { t: "Cl. 12 - Foro esclusivo", s: "Vessatoria" },
        { t: "Cl. 15 - Recesso", s: "Vessatoria" },
      ],
      drafting: [
        { t: "Art. 1454 c.c.", s: "Diffida" },
        { t: "Art. 1218 c.c.", s: "Inadempimento" },
        { t: "Modello studio", s: "Riutilizzato" },
      ],
      matters: [
        { t: "Rossi c. Banca", s: "7 giorni" },
        { t: "Bianchi", s: "5 giorni" },
        { t: "Verdi", s: "3 giorni" },
      ],
      calendar: [
        { t: "Mar 09:30", s: "Trib. Milano" },
        { t: "Gio 11:00", s: "Trib. Roma" },
        { t: "Ven 14:30", s: "CdA Torino" },
      ],
    },
    metrics: {
      research: [
        { k: "Fonti", v: "12" },
        { k: "Tempo", v: "1.4s" },
        { k: "Affidab.", v: "98%" },
      ],
      analysis: [
        { k: "Pagine", v: "24" },
        { k: "Alert", v: "3" },
        { k: "Confidenza", v: "94%" },
      ],
      drafting: [
        { k: "Parole", v: "412" },
        { k: "Riferimenti", v: "5" },
        { k: "Tempo", v: "2.1s" },
      ],
      matters: [
        { k: "Aperte", v: "27" },
        { k: "In scadenza", v: "4" },
        { k: "Chiuse mese", v: "11" },
      ],
      calendar: [
        { k: "Udienze", v: "3" },
        { k: "Scadenze", v: "4" },
        { k: "Promemoria", v: "8" },
      ],
    },
  },
  hero: {
    badge: "Intelligenza artificiale per il diritto",
    titleA: "L'AI legale che cita",
    titleB: "sempre le sue fonti.",
    subtitle:
      "Ogni risposta è ancorata a norme, giurisprudenza e ai tuoi documenti. L'AI assiste e cita, non sostituisce il giudizio del professionista.",
    ctaPrimary: "Prova LexAIPro",
    ctaSecondary: "Richiedi una demo",
    kicker: "Numero 01 — Legal Intelligence",
    quote: "Uno strumento indispensabile per lo studio che guarda al futuro con rigore e visione.",
    quoteAttr: "La redazione LexAIPro",
    badges: { gdpr: "GDPR", crypto: "Crittografia AES-256", aiAct: "AI Act EU", euData: "Dati in EU" },
    stats: { sources: "Fonti consultabili", time: "Tempo risparmiato", pros: "Professionisti", draft: "Per generare bozza" },
  },
  heroTrace: {
    question: "Recesso del committente nell'appalto privato: limiti e indennizzo all'appaltatore?",
    questionLabel: "Domanda",
    responseLabel: "Risposta tracciata",
    verified: "Ogni passaggio è collegato alla sua fonte",
    sourcesLabel: "Fonti citate",
    hint: "Passa o seleziona una frase con Tab per vederne le fonti",
    segments: {
      s1: "Il committente può recedere dal contratto in qualunque momento",
      s2: "tenendo indenne l'appaltatore delle spese sostenute, dei lavori eseguiti e del mancato guadagno",
      s3: "La giurisprudenza richiede che il recesso sia comunicato in forma idonea e non abusiva",
      s4: "Nel tuo contratto la clausola 9 disciplina espressamente le modalità di recesso",
    },
    sources: {
      a1: { ref: "art. 1671 c.c.", kind: "Codice civile", note: "Recesso unilaterale del committente" },
      a2: { ref: "Cass. civ. 2855/2021", kind: "Giurisprudenza", note: "Indennizzo e mancato guadagno" },
      a3: { ref: "Contratto · clausola 9", kind: "Documento caricato", note: "Modalità di recesso pattuite" },
    },
  },
  tracciabilita: {
    eyebrow: "Tracciabilità",
    title: "Ogni risposta poggia su una fonte che puoi consultare",
    subtitle: "LexAIPro non genera affermazioni a vuoto: collega ogni passaggio alla norma, alla sentenza o al documento da cui deriva. Tu verifichi, decidi e firmi.",
    sources: {
      law: {
        title: "Codici e leggi",
        desc: "Articoli di codici, leggi e decreti citati con riferimento puntuale (es. art. 1671 c.c.) e link al testo vigente.",
        tag: "Normativa",
      },
      caselaw: {
        title: "Giurisprudenza",
        desc: "Pronunce di Cassazione, Corte costituzionale e merito con estremi completi e massima collegata.",
        tag: "Sentenze",
      },
      docs: {
        title: "Tuoi documenti",
        desc: "Clausole e passaggi dei file che carichi, citati con pagina e sezione per un riscontro immediato.",
        tag: "Documenti",
      },
    },
    steps: {
      cite: { title: "Cita", desc: "Ogni frase rilevante è ancorata alla fonte che la giustifica." },
      link: { title: "Collega", desc: "Apri il riferimento e leggi il testo originale, senza uscire dal contesto." },
      verify: { title: "Verifica", desc: "Confermi la pertinenza e mantieni il controllo del giudizio professionale." },
    },
    note: "L'AI assiste e cita le fonti, non sostituisce il giudizio del professionista. Per le aree in rapida evoluzione segnaliamo di verificare gli aggiornamenti più recenti.",
    cta: "Vedi come funziona la tracciabilità",
  },
  audience: {
    eyebrow: "Per chi è",
    title: "Pensato per chi esercita il diritto, ogni giorno",
    subtitle: "Stesso rigore, tre modi di lavorare. LexAIPro si adatta al tuo contesto professionale.",
    segments: {
      lawyer: {
        name: "Avvocati",
        tagline: "Singoli professionisti",
        desc: "Ricerca, analisi e redazione in un unico flusso. Più tempo per la strategia, meno per il lavoro ripetitivo.",
        points: [
          "Ricerca legale con fonti citate e verificabili",
          "Bozze di atti e pareri in pochi minuti",
          "Analisi documenti con estrazione clausole e rischi",
        ],
      },
      firm: {
        name: "Studi legali",
        tagline: "Team e collaboratori",
        desc: "Conoscenza condivisa e standard di qualità uniformi tra soci, associati e praticanti.",
        points: [
          "Spazi di lavoro condivisi per pratica",
          "Template e prompt riutilizzabili dal team",
          "Coerenza di citazioni e stile redazionale",
        ],
      },
      corporate: {
        name: "Uffici legali d'impresa",
        tagline: "Team legali aziendali",
        desc: "Velocità sui volumi contrattuali, con controllo, riservatezza e tracciabilità per ogni decisione.",
        points: [
          "Analisi e confronto di contratti su larga scala",
          "Riservatezza e dati conservati nell'UE",
          "Audit trail su ricerche e documenti generati",
        ],
      },
    },
    cta: "Inizia la prova gratuita",
    ctaSecondary: "Parla con noi",
  },
  contact: {
    eyebrow: "Contatti",
    title: "Parliamo del tuo studio",
    subtitle: "Raccontaci come lavori: ti mostriamo LexAIPro sui tuoi casi reali. Risposta entro un giorno lavorativo.",
    form: {
      name: "Nome e cognome",
      namePlaceholder: "Mario Rossi",
      email: "Email",
      emailPlaceholder: "nome@studio.it",
      organization: "Studio o azienda",
      organizationPlaceholder: "Studio Legale Rossi",
      segment: "Sei…",
      segments: {
        avvocato: "Avvocato",
        studio: "Studio legale",
        azienda: "Ufficio legale d'impresa",
        altro: "Altro",
      },
      message: "Messaggio",
      messagePlaceholder: "Descrivi brevemente le tue esigenze…",
      submit: "Invia richiesta",
      submitting: "Invio in corso…",
      whatsapp: "Scrivici su WhatsApp",
      success: "Richiesta inviata. Ti ricontattiamo a breve.",
      error: "Invio non riuscito. Riprova o scrivici su WhatsApp.",
      privacy: "Inviando accetti il trattamento dei dati secondo la Privacy Policy. I dati restano nell'UE.",
    },
  },
  features: {
    eyebrow: "Tre pilastri",
    title: "Tutto ciò di cui hai bisogno per esercitare meglio",
    subtitle: "LexAIPro non sostituisce l'avvocato. Amplifica il tuo giudizio eliminando il lavoro ripetitivo.",
    items: {
      research: { title: "Ricerca Legale AI", desc: "Fai domande in linguaggio naturale su legislazione, giurisprudenza e dottrina italiana ed europea. Risposte strutturate con fonti verificabili e citazioni precise." },
      analysis: { title: "Analisi Documenti", desc: "Carica qualsiasi documento legale. Ottieni sintesi, estrazione clausole, analisi rischi e confronto versioni in pochi secondi. Anche in più lingue." },
      drafting: { title: "Redazione Assistita", desc: "Genera bozze di atti, contratti e pareri con istruzioni in linguaggio naturale. Itera fino al risultato perfetto. Oltre 40 template professionali inclusi." },
    },
  },
  areas: {
    eyebrow: "Aree legali coperte",
    title: "Specialista in ogni materia",
    hint: "Scorri per esplorare tutte le aree →",
    active: "Attivo",
    scrollLeft: "Scorri a sinistra",
    scrollRight: "Scorri a destra",
    items: {
      civil: { name: "Civile", desc: "Contratti, responsabilità, obbligazioni" },
      commercial: { name: "Commerciale", desc: "Società, M&A, governance" },
      labor: { name: "Lavoro", desc: "Contratti, licenziamenti, sindacale" },
      tax: { name: "Tributario", desc: "Contenzioso, accertamenti, IVA" },
      privacy: { name: "Privacy & GDPR", desc: "DPIA, registri, compliance" },
      banking: { name: "Bancario", desc: "Mutui, anatocismo, NPL" },
      criminal: { name: "Penale", desc: "Reati comuni, white collar, 231" },
      ip: { name: "Proprietà Intellettuale", desc: "Marchi, brevetti, copyright" },
      admin: { name: "Amministrativo", desc: "Appalti, urbanistica, ricorsi" },
      bankruptcy: { name: "Fallimentare", desc: "Crisi d'impresa, concordati" },
    },
  },
  demo: {
    eyebrow: "Provala in azione",
    title: "Vedi LexAIPro all'opera",
    subtitle: "Demo interattiva: clicca, scrivi, esplora.",
    tabs: { research: "Ricerca", analysis: "Analisi", drafting: "Redazione" },
    today: "Oggi",
    freeQuestions: "Domande gratuite",
    question: "Domanda",
    searching: "Ricerca in corso…",
    retry: "Riprovare",
    exhaustedTitle: "Hai esaurito le 2 domande gratuite",
    exhaustedDesc: "Registrati per continuare con risposte illimitate, fonti citate verificate e analisi di documenti.",
    startFree: "Inizia gratis",
    seePlans: "Vedi piani",
    inputPlaceholder: "Fai una domanda legale…",
    sending: "Invio…",
    ask: "Chiedi",
    errors: {
      exhausted: "Hai esaurito le 2 domande gratuite.",
      service: "Errore del servizio. Riprova.",
      generic: "Errore. Riprova.",
      offline: "Connessione assente. Riprova.",
    },
    presets: {
      prescrizione: {
        label: "Termini prescrizione",
        question: "Quali sono i termini di prescrizione per la responsabilità extracontrattuale?",
        area: "Civile",
        answer: "L'azione di risarcimento del danno da fatto illecito si prescrive in <strong>cinque anni</strong> dal giorno in cui il fatto si è verificato, ex <span class=\"font-mono text-xs bg-primary/10 px-1 rounded\">art. 2947, c. 1, c.c.</span> Per i danni derivanti dalla circolazione di veicoli, il termine si riduce a <strong>due anni</strong>.",
        sources: [
          { icon: "📜", title: "art. 2947 c.c.", desc: "Il diritto al risarcimento del danno…" },
          { icon: "⚖️", title: "Cass. Sez. III, n. 7123/2024", desc: "Decorrenza dies a quo" },
        ],
      },
      risarcimento: {
        label: "Risarcimento danni",
        question: "Come si quantifica il danno non patrimoniale?",
        area: "Civile",
        answer: "Il danno non patrimoniale (art. <span class=\"font-mono text-xs bg-primary/10 px-1 rounded\">2059 c.c.</span>) è risarcibile in via <strong>equitativa</strong>: si applicano le <strong>Tabelle di Milano 2024</strong> per il danno biologico e morale, con personalizzazione fino al 30% in presenza di circostanze peculiari.",
        sources: [
          { icon: "📜", title: "art. 2059 c.c.", desc: "Danno non patrimoniale" },
          { icon: "📊", title: "Tabelle Milano 2024", desc: "Liquidazione danno biologico" },
          { icon: "⚖️", title: "Cass. SS.UU. 26972/2008", desc: "Sentenze gemelle" },
        ],
      },
      recesso: {
        label: "Recesso contrattuale",
        question: "Quando è ammesso il recesso unilaterale dal contratto?",
        area: "Civile",
        answer: "Il recesso è ammesso solo se previsto dalle parti (<span class=\"font-mono text-xs bg-primary/10 px-1 rounded\">art. 1373 c.c.</span>) o dalla legge. Nei contratti a esecuzione continuata, il recesso non ha effetto retroattivo. Per i contratti dei consumatori si aggiunge il <strong>diritto di ripensamento</strong> di 14 giorni.",
        sources: [
          { icon: "📜", title: "art. 1373 c.c.", desc: "Recesso unilaterale" },
          { icon: "🛡️", title: "D.Lgs. 206/2005", desc: "Codice del consumo art. 52" },
        ],
      },
    },
    customArea: "Generale",
    analysis: {
      docMeta: "Contratto di Locazione Commerciale.pdf · pagina 3 di 8 - clicca una clausola",
      riskScore: "Risk Score",
      risk: { low: "BASSO", med: "MEDIO", high: "ALTO" },
      clauses: [
        { id: "c1", level: "ok", text: "Il canone di locazione è pari a euro 24.000 annui", suffix: ", da corrispondersi in dodici rate mensili anticipate.", title: "Conforme", note: "Canone e modalità di pagamento sono in regola." },
        { id: "c2", level: "warn", text: "Il conduttore si impegna ad eseguire a propria cura e spese tutti gli interventi di manutenzione straordinaria", suffix: " dell'immobile.", title: "Attenzione", note: "Deroga all'art. 1576 c.c. - generalmente a carico del locatore. Verificare equilibrio contrattuale." },
        { id: "c3", level: "risk", text: "In caso di ritardo nel pagamento, il locatore potrà risolvere il contratto senza preavviso", suffix: ", trattenendo il deposito cauzionale.", title: "Clausola problematica", note: "La risoluzione senza preavviso contrasta con l'art. 27 L. 392/1978." },
      ],
    },
    drafting: {
      docTitle: "CONTRATTO DI PRESTAZIONE D'OPERA INTELLETTUALE",
      intro: "Tra {{a}}, C.F. {{b}}…",
      art1Title: "Art. 1 - Oggetto",
      art1: "Il professionista si obbliga a prestare la propria opera intellettuale in favore del cliente per…",
      art2Title: "Art. 2 - Compenso",
      art2: "Il compenso pattuito è di euro {{importo}}, oltre IVA…",
      art3Title: "Art. 3 - Decorrenza",
      art3: "Il presente contratto decorre dal {{data}}.",
      art4Title: "Art. 4 - Riservatezza",
      art4: "Le parti si impegnano a mantenere riservate tutte le informazioni acquisite nell'esecuzione del presente contratto, anche dopo la cessazione dello stesso.",
      aiSuggestion: "Suggerimento AI",
      ndaAdded: "✓ Clausola di riservatezza aggiunta.",
      ndaPrompt: "Manca clausola di riservatezza. Vuoi aggiungerla?",
      ndaCta: "Aggiungi clausola",
      variables: "Variabili",
    },
  },
  howItWorks: {
    eyebrow: "Come funziona",
    title: "Tre passi. Risultati in secondi.",
    items: {
      ask: { title: "Fai una domanda", desc: "Scrivi in linguaggio naturale, come parleresti a un collega di studio." },
      analyze: { title: "LexAIPro analizza", desc: "Ricerca su 5M+ fonti verificate: legislazione, giurisprudenza, dottrina." },
      results: { title: "Ottieni risultati", desc: "Risposta strutturata con citazioni precise, pronta per il tuo lavoro." },
    },
  },
  testimonials: {
    eyebrow: "Testimonianze",
    title: "Scelto dai professionisti",
    aria: "Testimonianza",
  },
  security: {
    eyebrow: "Sicurezza",
    title: "Sicurezza senza compromessi. Sempre.",
    subtitle: "Costruita sui principi di privacy by design e conformità europea.",
    badges: { gdpr: "GDPR Compliant", aiAct: "AI Act EU Compliant" },
    quote: "\"La sicurezza non è un'opzione aggiuntiva: è la nostra fondazione.\"",
    pillars: {
      training: { title: "Zero Training sui Tuoi Dati", desc: "I tuoi documenti non vengono mai utilizzati per addestrare i nostri modelli AI. Protezione assoluta." },
      retention: { title: "Zero Retention Policy", desc: "I documenti caricati vengono eliminati dal server dopo l'elaborazione. Non li conserviamo." },
      crypto: { title: "Crittografia End-to-End", desc: "Crittografia in transito (TLS 1.3) e a riposo (AES-256) su tutti i dati." },
      eu: { title: "Data Residency EU/Italia", desc: "I tuoi dati risiedono esclusivamente su server europei. Conformità totale GDPR." },
    },
  },
  pricing: {
    eyebrow: "Prezzi",
    title: "Trasparenti. Scalabili. Senza sorprese.",
    notice: "Pagamenti in attivazione · iscriviti per essere avvisato al lancio",
    monthly: "Mensile",
    annual: "Annuale",
    perMonth: "/mese",
    onRequest: "Su richiesta",
    save: "Risparmi €{{amount}}/anno",
    mostChosen: "Più scelto",
    notify: "Avvisami al lancio",
    orFree: "oppure crea un account gratuito",
    footer: "Beta gratuita aperta · I primi iscritti alla waitlist riceveranno uno sconto early-bird al lancio",
    plans: {
      starter: { name: "Starter", desc: "Per il professionista singolo", features: ["1 utente","100 query AI/mese","Storage 10 GB","Ricerca AI","Analisi base","Support email"] },
      pro: { name: "Professional", desc: "Per chi lavora a tutto campo", features: ["1 utente","Query AI illimitate","Storage 50 GB","Ricerca AI avanzata","Analisi avanzata","Redazione atti","Template premium","Support prioritario"] },
      studio: { name: "Studio", desc: "Per studi e team aziendali", features: ["Da 5 utenti","Tutto Professional","SSO aziendale","API Access","Gestione Team","Account Manager","SLA garantito"] },
    },
  },
  faq: {
    eyebrow: "FAQ",
    title: "Domande frequenti",
    items: [
      { q: "LexAIPro può sostituire un avvocato?", a: "Assolutamente no. LexAIPro è uno strumento professionale progettato per assistere e amplificare il giudizio dell'avvocato, non per sostituirlo. Le decisioni legali finali restano sempre nelle mani del professionista." },
      { q: "I miei documenti sono al sicuro?", a: "Sì. Applichiamo una zero retention policy: i documenti vengono eliminati dai nostri server dopo l'elaborazione. Inoltre, i tuoi dati non vengono mai utilizzati per addestrare i modelli AI." },
      { q: "Funziona solo per il diritto italiano?", a: "Il sistema è ottimizzato per il diritto italiano (codici, leggi, giurisprudenza), con copertura del diritto europeo. Stiamo espandendo la copertura ad altri ordinamenti EU." },
      { q: "Posso provarlo gratis?", a: "Sì, offriamo 14 giorni di prova gratuita su tutti i piani senza richiedere carta di credito. Puoi annullare in qualsiasi momento." },
      { q: "Quali documenti posso analizzare?", a: "Tutti i principali formati: PDF, DOCX, DOC, TXT, RTF, HTML, ODT. Massimo 50 MB per file e fino a 10 file per upload." },
      { q: "Le citazioni sono affidabili?", a: "LexAIPro cita sempre la fonte normativa o giurisprudenziale. Per aree in rapida evoluzione, segnaliamo esplicitamente la necessità di verificare aggiornamenti recenti." },
      { q: "Posso integrarlo con il mio gestionale?", a: "Sì. Il piano Studio include API access. Sono disponibili integrazioni native con Google Workspace, Microsoft 365, DocuSign e altri tool." },
      { q: "Cosa succede se supero le query incluse nel piano?", a: "Sul piano Starter ti mostriamo un avviso al raggiungimento del limite e puoi fare upgrade in un click. Sul piano Professional le query sono illimitate." },
    ],
  },
  finalCta: {
    titleA: "Inizia la tua prova gratuita di",
    titleHl: "14 giorni",
    subtitle: "Nessuna carta di credito richiesta. Setup in meno di un minuto.",
    primary: "Crea il tuo account",
    secondary: "Esplora la demo",
  },
  footer: {
    tagline: "Intelligenza artificiale per professionisti legali. Niente spam: solo aggiornamenti pratici.",
    newsletter: "Newsletter", emailPlaceholder: "La tua email", subscribe: "Iscrivimi", confirmed: "Iscrizione confermata.", support: "Assistenza",
    columns: { product: "Prodotto", company: "Azienda", legal: "Legale" },
    links: { features: "Funzionalità", pricing: "Prezzi", demo: "Demo", security: "Sicurezza", about: "Chi siamo", blog: "Blog", contact: "Contatti", glossary: "Glossario", privacy: "Privacy Policy", terms: "Termini & Condizioni", refunds: "Politica di Rimborso", gdpr: "GDPR" },
    badges: { euData: "Dati in EU", gdpr: "GDPR", aiAct: "AI Act" },
    login: "Login",
    whatsapp: "Vendite WhatsApp",
  
  },
  notFound: { title: "Pagina non trovata", desc: "La pagina che cerchi non esiste o è stata spostata.", cta: "Torna alla home" },
  language: { label: "Lingua", it: "Italiano", en: "English" },
  waitlist: {
    titleWaitlist: "Avvisami al lancio",
    titleNewsletter: "Iscriviti alla newsletter",
    descWaitlist: "I pagamenti sono in attivazione{{plan, select, undefined { } other { per il piano {{plan}} }}}. Lascia la tua email: i primi iscritti riceveranno uno sconto early-bird dedicato.",
    descNewsletter: "Aggiornamenti pratici per avvocati, niente spam. Cancellazione con un click.",
    emailLabel: "Email",
    emailPlaceholder: "tu@studiolegale.it",
    subscribe: "Iscrivimi",
    sending: "Invio…",
    success: "Iscrizione confermata. Controlla la posta tra qualche minuto.",
    close: "Chiudi",
    consent: "Acconsenti al trattamento per ricevere aggiornamenti via email. Puoi disiscriverti in qualsiasi momento.",
    error: "Errore",
  },
  paymentsWip: {
    title: "Pagamenti in arrivo",
    desc: "I pagamenti non sono ancora attivi. Lasciaci la tua email: ti contatteremo appena tutto sarà pronto, e i primi iscritti riceveranno uno sconto early-bird.",
    emailLabel: "Email",
    notify: "Avvisami al lancio",
    sending: "Invio…",
    success: "Iscrizione confermata. Ti scriveremo non appena i pagamenti saranno attivi.",
    close: "Chiudi",
    note: "Nessuno spam. Puoi cancellarti in qualsiasi momento.",
    error: "Si è verificato un errore. Riprova.",
  },
  app: {
    sidebar: {
      studio: "Studio",
      mattersGroup: "Pratiche",
      productivity: "Produttività",
      communication: "Comunicazione",
      account: "Account",
      admin: "Amministrazione",
      homepage: "Homepage",
      dashboard: "Dashboard",
      research: "Ricerca AI",
      documents: "Documenti",
      analyses: "Analisi",
      history: "Storico",
      matters: "Pratiche",
      clients: "Clienti",
      calendar: "Scadenze",
      team: "Team",
      drafting: "Redazione",
      generator: "Genera documento",
      templates: "Template",
      billing: "Abbonamento",
      settings: "Impostazioni",
      wordAddin: "Word Add-in",
      docChat: "Chat documentale",
      inMatter: "in pratica",
      alerts: "Alert Normativi",
      soon: "presto",
      adminNav: "Admin",
      guide: "Guida all'uso",
      logout: "Esci",
    },
    topbar: {
      queries: "query",
      ofQueries: "{{used}} di {{limit}} query",
    },
    billing: {
      title: "Abbonamento",
      description: "Piano, utilizzo e cronologia pagamenti.",
      currentPlan: "Piano attuale",
      statusActive: "Attivo",
      statusPastDue: "Pagamento da regolarizzare",
      expiringOn: "In scadenza il {{date}}",
      resume: "Ripristina",
      cancelEow: "Annulla a fine periodo",
      paymentMethod: "Metodo di pagamento",
      aiQueriesUsed: "Query AI utilizzate",
      paymentsWipNotice: "Pagamenti in attivazione. I piani a pagamento non sono ancora acquistabili. Iscriviti alla waitlist: i primi riceveranno uno sconto early-bird al lancio.",
      changePlan: "Cambia piano",
      choosePlan: "Scegli un piano",
      activePlan: "Piano attivo",
      free: "Gratis",
      choose: "Scegli piano",
      notifyAtLaunch: "Avvisami al lancio",
      mostPopular: "Più popolare",
      seats: "Posti:",
      perMonth: "/mese",
      paymentsHistory: "Cronologia pagamenti",
      noPayments: "Nessun pagamento ancora.",
      colDate: "Data",
      colDescription: "Descrizione",
      colAmount: "Importo",
      colStatus: "Stato",
      invoice: "Fattura",
      cancelConfirm: "Annullare l'abbonamento? Manterrai l'accesso fino alla fine del periodo già pagato.",
      cancelScheduled: "Annullamento programmato per fine periodo.",
      restored: "Abbonamento ripristinato.",
      planUpdated: "Piano aggiornato. Conguaglio applicato proporzionalmente.",
      seatsUpdated: "Posti aggiornati.",
      cannotUpdate: "Impossibile aggiornare il piano",
      cannotUpdateSeats: "Impossibile aggiornare i posti",
      cannotCancel: "Impossibile annullare",
      cannotResume: "Impossibile ripristinare",
      cannotOpenCheckout: "Impossibile aprire checkout",
      onWaitlist: "Sei in lista d'attesa: ti avviseremo al lancio dei pagamenti.",
      tryAgain: "Riprova tra poco.",
      cycleMonthly: "Mensile",
      cycleAnnual: "Annuale",
      annualSave: "−20%",
      aiQueriesPerMonth: "{{n}} query AI/mese",
      allModulesIncluded: "Tutti i moduli inclusi",
      modulesIncluded_one: "{{count}} modulo Standard incluso",
      modulesIncluded_other: "{{count}} moduli Standard inclusi",
      modulesSoldSeparately: "Moduli vendibili separatamente",
      specializations: "Specializzazioni",
      specializationsDesc: "Attiva i moduli con cui l'AI risponde con system prompt, fonti e glossario dedicati. Sconto bundle: −15% da 3 moduli, −25% da 5.",
      includedTag: "Incluso",
      summaryPlan: "Piano {{name}}",
      summaryModules: "Moduli ({{n}})",
      summaryIncludedDiscount: "Inclusi nel piano",
      summaryBundleDiscount: "Sconto bundle ({{pct}}%)",
      summaryAnnualDiscount: "Sconto annuale ({{pct}}%)",
      summaryTotalMonthly: "Totale mensile",
      summaryTotalMonthlyBilledAnnual: "Totale mensile (fatturato annuo)",
      perYearAmount: "€{{amount}} all'anno",
      currentConfig: "Configurazione attuale",
      confirmAndPay: "Conferma e paga",
      selectAtLeastOne: "Seleziona almeno un piano o un modulo a pagamento.",
    },
    upgrade: {
      eyebrow: "Aggiorna piano",
      title: "Più crediti, più potenza",
      subtitle: "Scegli il piano adatto al tuo studio. Puoi cambiare o annullare in qualsiasi momento.",
      creditsCurrent: "Crediti del piano corrente · {{plan}}",
      aiRequests: "richieste AI",
      exhausted: "Crediti esauriti",
      exhaustedHint: "Le richieste AI sono temporaneamente bloccate. Aggiorna il piano per riprendere.",
      recommended: "Consigliato",
      perMonthQuota: "{{n}} richieste AI / mese",
      currentPlan: "Piano attuale",
      switchTo: "Passa a {{plan}}",
      included: "Già incluso",
      manageCurrent: "Gestisci abbonamento corrente",
      backToDashboard: "Torna al pannello",
      checkoutError: "Errore checkout",
    },
  },
  pages: {
    status: {
      open: "Aperta",
      new: "Nuova",
      in_analysis: "In analisi",
      in_progress: "In corso",
      awaiting_documents: "Attesa documenti",
      in_review: "In revisione",
      completed: "Completata",
      done: "Conclusa",
      closed: "Chiusa",
      archived: "Archiviata",
      cancelled: "Annullata",
      draft: "Bozza",
    },
    risk: {
      low: "Rischio basso",
      medium: "Rischio medio",
      high: "Rischio alto",
      critical: "Critico",
    },
    priority: {
      low: "Bassa",
      medium: "Media",
      high: "Alta",
      urgent: "Urgente",
    },
    verified: "Verificato",
    editor: {
      undo: "Annulla",
      redo: "Ripeti",
      h1: "Titolo 1",
      h2: "Titolo 2",
      h3: "Titolo 3",
      blockquote: "Citazione",
      bold: "Grassetto",
      italic: "Corsivo",
      underline: "Sottolineato",
      strike: "Barrato",
      highlight: "Evidenzia",
      alignLeft: "Sinistra",
      alignCenter: "Centro",
      alignRight: "Destra",
      alignJustify: "Giustifica",
      bulletList: "Lista puntata",
      orderedList: "Lista numerata",
      link: "Link",
      linkPrompt: "URL del link",
      table: "Tabella",
      hr: "Linea",
      aiContinue: "Continua con AI",
      aiGenerating: "Generazione…",
    },
    common: {
      loading: "Caricamento…",
      error: "Errore",
      saved: "Salvato",
      deleted: "Eliminato",
      delete: "Elimina",
      open: "Apri",
      close: "Chiudi",
      cancel: "Annulla",
      confirm: "Conferma",
      retry: "Riprova",
      back: "Indietro",
      search: "Cerca…",
      newSearch: "Nuova ricerca",
    },
    dashboard: {
      greeting: "Buongiorno, {{name}}.",
      greetingDefault: "Buongiorno, avvocato.",
      description: "Panoramica del tuo studio: pratiche, analisi recenti e prossime scadenze.",
      allGood: "Tutto in regola",
      newMatter: "Nuova pratica",
      newAnalysis: "Nuova analisi",
      overview: "Panoramica",
      openMatters: "Pratiche aperte",
      mattersTotal: "{{n}} totali",
      deadlines7d: "Scadenze 7gg",
      researchToday: "Ricerche oggi",
      documents: "Documenti",
      aiQueries: "Query AI",
      currentPeriod: "Periodo corrente",
      recentMatters: "Pratiche recenti",
      studio: "Studio",
      seeAll: "Vedi tutte →",
      noMatters: "Nessuna pratica",
      createMatter: "Crea pratica",
      recentAnalyses: "Analisi recenti",
      docs: "Documenti",
      historyArrow: "Storico →",
      noAnalyses: "Nessuna analisi",
      analyzeDoc: "Analizza documento",
      next7days: "Prossimi 7 giorni",
      calendar: "Calendario",
      openArrow: "Apri →",
      noDeadlines: "Nessuna scadenza",
      createEvent: "Crea evento",
      analysisDone: "Analisi completata",
      updated: "Agg. {{date}}",
      qaLibrary: "Libreria",
      qaLibraryDesc: "Carica e indicizza",
      qaAnalysis: "Analisi AI",
      qaAnalysisDesc: "Estrai rischi e clausole",
      qaGenerator: "Generatore",
      qaGeneratorDesc: "Bozze guidate",
      qaResearch: "Ricerca",
      qaResearchDesc: "Norme e giurisprudenza",
    },
    documents: {
      title: "Documenti",
      description: "Carica un documento per ottenere sintesi, estrazione clausole e confronto fra versioni.",
      tabSummary: "Sintesi",
      tabClauses: "Clausole e rischi",
      tabCompare: "Confronto",
      beta: "Beta",
      summaryTitle: "Sintesi del documento",
      summaryDesc: "Carica un PDF, DOCX o scansione e ottieni una sintesi strutturata in pochi secondi.",
      openAnalysis: "Apri analisi",
      clausesTitle: "Clausole e rischi",
      clausesDesc: "Rivedi le analisi precedenti con clausole estratte e classificazione del rischio.",
      seeHistory: "Vedi storico",
      compareTitle: "Confronto versioni",
      compareDesc: "Diff intelligente fra due bozze contrattuali con evidenza delle modifiche sostanziali. In arrivo.",
      comingSoon: "Disponibile a breve",
    },
    analyses: {
      title: "Cronologia analisi",
      description: "Tutti i documenti che hai analizzato con l'AI.",
      newAnalysis: "Nuova analisi",
      noneTitle: "Nessuna analisi ancora",
      noneDesc: "Carica un PDF e analizzalo per iniziare.",
      analyzeDocument: "Analizza un documento",
      analysisOf: "Analisi del {{date}}",
      backToHistory: "Cronologia",
      delete: "Elimina",
      deleteConfirm: "Eliminare questa analisi?",
      deleted: "Analisi eliminata",
      tabSummary: "Sintesi",
      tabParties: "Parti",
      tabDates: "Date",
      tabClauses: "Clausole",
      tabRisks: "Rischi",
      suggestedActions: "Azioni consigliate",
      sevHigh: "Alto",
      sevMedium: "Medio",
      sevLow: "Basso",
      mitigation: "Mitigazione",
      partiesCount: "{{n}} parti",
      clausesCount: "{{n}} clausole",
      risksCount: "{{n}} rischi",
      risksHigh: "({{n}} alti)",
    },
    history: {
      eyebrow: "Storico",
      title: "Le tue ricerche: {{n}} risultati",
      description: "Storico di ricerche, redazioni e analisi.",
      newFolder: "Crea cartella",
      newSearch: "Nuova ricerca",
      filterAll: "Tutti",
      kindAsk: "Chiedi a LexAI",
      kindDraft: "Redazione Atto",
      kindCompare: "Conformi e Difformi",
      allFolders: "Tutte",
      noFolder: "Senza cartella",
      noResults: "Nessuna ricerca trovata",
      startFirst: "Inizia la tua prima ricerca",
      colName: "Nome",
      colDate: "Data",
      colKind: "Tipo",
      delete: "Elimina",
      open: "Apri",
      deleteConfirm: "Eliminare la ricerca?",
      folderNamePrompt: "Nome cartella",
    },
    library: {
      title: "Libreria privata",
      description: "Documenti: {{n}} / {{quota}}. Ricercabili e organizzati.",
      searchPlaceholder: "Cerca per nome o tag…",
      docsCount: "{{n}} documenti",
      dropActive: "Rilascia per caricare",
      dropIdle: "Trascina file qui o clicca per selezionare",
      dropHint: "PDF, DOCX, immagini · max 50MB",
      emptyTitle: "Libreria vuota",
      emptyDesc: "Carica documenti per iniziare.",
      indexed: "Indicizzato",
      notIndexed: "Non indicizzato",
      indexBtn: "Indicizza per ricerca semantica",
      uploadFailed: "Upload fallito: {{name}}",
      uploaded: "Caricato: {{name}}",
      indexedToast: "Indicizzato: {{name}} ({{n}} chunk)",
      indexFailed: "Indicizzazione fallita",
      invalidSession: "Sessione non valida",
      deleteConfirm: 'Eliminare "{{name}}"?',
    },
    research: {
      eyebrow: "Ricerca legale",
      placeholder: "Cosa vuoi sapere?",
      filterPlaceholder: "Filtra ricerche",
      filterAll: "Tutte",
      filterAsk: "Ricerca",
      filterDraft: "Atti",
      filterCompare: "Sentenze",
      folders: "Cartelle",
      newFolder: "Nuova cartella",
      folderCreated: "Cartella creata",
      folderDeleted: "Cartella eliminata",
      folderNamePrompt: "Nome cartella",
      folderRenamePrompt: "Nuovo nome",
      folderDeleteConfirm: 'Eliminare la cartella "{{name}}"? Le ricerche resteranno.',
      noSessions: "Nessuna sessione.",
      noFolder: "Senza cartella",
      newSearch: "Nuova ricerca",
      compare: "Confronta",
      credits: "Crediti",
      undo: "Annulla",
      revisionUndone: "Ultima revisione annullata",
      revisionLimit: "Limite revisioni raggiunto",
      requestLimit: "Limite richieste raggiunto.",
      streamError: "Errore stream",
      requestError: "Errore durante la richiesta",
      composerPlaceholder: "Inserisci il quesito...",
      disclaimer: "Le informazioni generate da LexAIPro sono elaborate mediante l'utilizzo di AI e non hanno valenza di un parere di un professionista legale.",
      tabSources: "Fonti",
      tabSentences: "Sentenze",
      tabRevisions: "Revisioni",
      libraryHeader: "Libreria LexAI ({{n}})",
      sourcesZip: "ZIP fonti",
      sourcesEmpty: "Le fonti normative recuperate compariranno qui dopo una ricerca.",
      pdfArticle: "PDF articolo",
      aiBrief: "Scheda AI",
      briefGenerated: "Scheda generata",
      sentenceFilters: { all: "Tutte", conformi: "Conformi", difformi: "Difformi" },
      sentencesHint: "Per cercare sentenze conformi e difformi, avvia una nuova ricerca in modalità Conformi e Difformi dalla home.",
      revisions: "Revisioni",
      revisionPlaceholder: "Scrivi cosa vuoi modificare nella risposta...",
      applyRevision: "Applica revisione",
      noRevisionsLeft: "Hai esaurito le revisioni di questa sessione.",
      savePrompt: "Salva prompt",
      savedPrompts: "Prompt salvati ({{n}})",
      noSavedPrompts: "Nessun prompt salvato.",
      promptSaved: "Prompt salvato",
      writePromptFirst: "Scrivi prima un prompt",
      query: "Quesito",
      copy: "Copia",
      listen: "Ascolta",
      report: "Segnala",
      copied: "Copiato",
      reported: "Segnalazione inviata",
      ttsUnavailable: "Sintesi vocale non disponibile",
      emptyTitle: "Cosa vuoi sapere?",
      emptyDesc: "Risposte fondate su normativa italiana, con citazioni verificabili articolo per articolo.",
      verifiedCitations: "Citazioni verificate",
      officialSources: "Fonti ufficiali",
      newSessionTitle: "Nuova ricerca",
      suggestions: [
        "Termini di prescrizione per responsabilità extracontrattuale",
        "Requisiti del licenziamento per giusta causa",
        "Differenza fra dolo eventuale e colpa cosciente",
        "Recesso unilaterale nel contratto d'appalto",
      ],
      downloadFailed: "Download fallito",
      generateFailed: "Generazione fallita",
      exportFailed: "Esportazione fallita",
      preparingZip: "Preparazione ZIP di {{n}} fonti...",
      zipReady: "ZIP pronto ({{kb}} KB)",
      rename: "Rinomina",
    },
    matters: {
      title: "Pratiche",
      description: "Gestisci tutte le tue pratiche in stile Kanban.",
      newMatter: "Nuova pratica",
      colOpen: "Aperte",
      colInProgress: "In corso",
      colClosed: "Chiuse",
      emptyTitle: "Nessuna pratica",
      emptyDesc: "Crea la tua prima pratica.",
      createMatter: "Crea pratica",
      noneInColumn: "Nessuna pratica",
      openChat: "Apri chat documentale",
      moveTo: "→ {{label}}",
      edit: "Modifica",
      delete: "Elimina",
      modalNew: "Nuova pratica",
      modalEdit: "Modifica pratica",
      save: "Salva",
      create: "Crea",
      fName: "Nome",
      fNumber: "Numero",
      fType: "Tipo",
      fTypePh: "Civile, penale...",
      fValue: "Valore (EUR)",
      fStatus: "Stato",
      fDescription: "Descrizione",
      nameRequired: "Nome pratica obbligatorio",
      created: "Pratica creata",
      updated: "Pratica aggiornata",
      deleted: "Pratica eliminata",
      deleteConfirm: 'Eliminare "{{name}}"?',
    },
    clients: {
      title: "Clienti",
      description: "Anagrafica clienti con validazione P.IVA e Codice Fiscale italiani.",
      newClient: "Nuovo cliente",
      emptyTitle: "Nessun cliente ancora",
      emptyDesc: "Crea il tuo primo cliente per iniziare.",
      createClient: "Crea cliente",
      modalNew: "Nuovo cliente",
      modalEdit: "Modifica cliente",
      save: "Salva",
      fName: "Nome / Ragione sociale",
      fEmail: "Email",
      fPhone: "Telefono",
      fVat: "P.IVA",
      fFiscalCode: "Codice Fiscale",
      fAddress: "Indirizzo",
      fNotes: "Note",
      edit: "Modifica",
      delete: "Elimina",
      nameRequired: "Nome obbligatorio",
      vatInvalid: "P.IVA non valida",
      fiscalCodeInvalid: "Codice fiscale non valido",
      created: "Cliente creato",
      updated: "Cliente aggiornato",
      deleted: "Cliente eliminato",
      deleteConfirm: 'Eliminare "{{name}}"?',
    },
    settings: {
      title: "Impostazioni",
      description: "Profilo professionale e preferenze.",
      profileSection: "Profilo professionale",
      passwordSection: "Cambia password",
      passwordHint: "Almeno 8 caratteri.",
      newPassword: "Nuova password",
      confirmPassword: "Conferma",
      updatePassword: "Aggiorna password",
      updating: "Aggiornamento...",
      passwordTooShort: "Min 8 caratteri",
      passwordsMismatch: "Le password non coincidono",
      passwordUpdated: "Password aggiornata",
      fName: "Nome",
      fLastName: "Cognome",
      fFirm: "Studio",
      fBarOrder: "Ordine",
      fBarOrderPh: "Es. Milano",
      fBarNumber: "Numero iscrizione",
      fPhone: "Telefono",
      fPec: "PEC",
      saveChanges: "Salva modifiche",
      saving: "Salvataggio...",
      profileUpdated: "Profilo aggiornato",
      deleteSection: "Elimina account",
      deleteDesc: "Cancella in modo permanente l'account e tutti i dati associati. Eventuali abbonamenti attivi verranno annullati.",
      deleteCta: "Elimina il mio account",
      deleting: "Eliminazione...",
      deleteConfirm: "Eliminare definitivamente l'account? Tutti gli abbonamenti attivi verranno annullati e i dati cancellati. Operazione irreversibile.",
      accountDeleted: "Account eliminato",
      deleteError: "Errore eliminazione",
    },
    calendar: {
      title: "Calendario",
      description: "Scadenze, udienze, appuntamenti.",
      newEvent: "Nuovo evento",
      emptyTitle: "Nessun evento in arrivo",
      emptyDesc: "Tutti gli eventi futuri appariranno qui.",
      createFirst: "Crea il primo evento",
      modalNew: "Nuovo evento",
      createEvent: "Crea evento",
      fTitle: "Titolo *",
      fStart: "Inizio *",
      fEnd: "Fine",
      fType: "Tipo",
      fPriority: "Priorità",
      fLocation: "Luogo",
      fLocationPh: "Tribunale di Milano, aula 12…",
      fNotes: "Note",
      titleRequired: "Titolo obbligatorio",
      startRequired: "Data inizio obbligatoria",
      created: "Evento creato",
      deleted: "Eliminato",
      deleteConfirm: "Eliminare questo evento?",
      ariaDelete: "Elimina",
      types: { hearing: "Udienza", deadline: "Scadenza", appointment: "Appuntamento", reminder: "Promemoria" },
      priorities: { low: "Bassa", medium: "Media", high: "Alta", urgent: "Urgente" },
    },
    moduli: {
      title: "I miei moduli",
      description: "Configura piano, ciclo e specializzazioni. Vedi il totale in tempo reale prima di procedere.",
      goBilling: "Vai a Fatturazione",
      currentConfig: "Configurazione attuale",
      summaryLine: "{{plan}} · {{cycle}} · {{n}} moduli",
      cycleAnnual: "Annuale",
      cycleMonthly: "Mensile",
      currentCost: "Costo attuale",
      perMonth: "/mese",
      planAndCycle: "Piano e ciclo (preview)",
      annualBadge: "−20%",
      allModulesIncluded: "Tutti i moduli inclusi",
      includedStandard: "{{n}} moduli Standard inclusi",
      modulesApart: "Moduli a parte",
      specializations: "Specializzazioni",
      specializationsDesc: "Attiva o disattiva i moduli. Il totale a sinistra si aggiorna in tempo reale.",
      planLabel: "Piano {{name}}",
      modulesLabel: "Moduli ({{n}})",
      includedDiscount: "Inclusi nel piano",
      bundleDiscount: "Sconto bundle ({{pct}}%)",
      cycleDiscount: "Sconto annuale ({{pct}}%)",
      totalAnnualBilled: "Totale mensile (fatturato annuo)",
      totalMonthly: "Totale mensile",
      perYear: "€{{amount}} all'anno",
      currentSel: "Configurazione attuale",
      confirmPay: "Conferma e paga",
      noPaidItems: "Nessun elemento a pagamento da acquistare.",
      confirmTitle: "Confermi la nuova configurazione?",
      switchingTo: "Stai per passare a:",
      itemPlan: "Piano {{plan}} ({{cycle}})",
      itemModules: "{{n}} moduli ({{names}})",
      itemNone: "nessuno",
      itemTotal: "Totale stimato: €{{total}}/mese",
      itemTotalAnnual: " · €{{annual}}/anno",
      checkoutHint: "Verrai indirizzato al checkout sicuro Paddle.",
      cancel: "Annulla",
      proceed: "Procedi al checkout",
    },
    agenti: {
      title: "Agenti Studio",
      description: "10 agenti AI specializzati per uno studio legale italiano.",
      history: "Cronologia",
      dashboard: "Cruscotto",
      claudeBadge: "CLAUDE",
      docBadge: "DOC",
      promptShort: "{{category}} · v{{v}}",
      backToAll: "Tutti gli agenti",
      promptVer: "{{short}} · prompt v{{v}}",
      docsLabel: "Documenti di contesto (PDF, DOCX, TXT — max 5)",
      extracting: "Estrazione testo…",
      dropFiles: "Trascina o seleziona file",
      tooLarge: "{{name}}: troppo grande (max 10MB)",
      extractError: "{{name}}: {{err}}",
      extractedChars: "{{name}}: {{n}} caratteri estratti",
      charSuffix: "({{n}} char)",
      processing: "Elaborazione…",
      runAgent: "Esegui agente",
      versionBadge: "v{{n}}",
      agentMeta: "Agente: {{id}} · prompt v{{v}}",
      engineLabel: "· Motore: {{engine}}",
      regenerate: "Rigenera con modifiche",
      whatToFix: "Cosa correggere?",
      regenPlaceholder: "Es. aggiungi sezione sui rischi 231, riformula la sezione 3 in tono più cauto…",
      generating: "Generazione…",
      genV: "Genera v{{n}}",
      cancel: "Annulla",
      versionsTitle: "Cronologia versioni",
      versionLine: "v{{n}} · {{date}}",
      genericError: "Errore",
      networkError: "Errore di rete",
      versionGen: "v{{n}} generata · {{engine}}",
      upgradeTitle: "Agenti Studio richiesti",
      upgradeDesc: "Per usare questo agente serve il piano Studio (Claude Sonnet 4.5 + GPT-5.2).",
      wallTitle: "Agenti Studio",
      wallDesc: "10 agenti AI specializzati (KYC, Due Diligence M&A, Brief Udienza, Audit GDPR…) potenziati da GPT-5.2 e Claude Sonnet 4.5. Disponibili solo nel piano Studio.",
      upgradeStudio: "Passa a Studio",
      requiredMark: "*",
      dashOnly: "Cruscotto disponibile solo nel piano Studio.",
      dashTitle: "Cruscotto Studio",
      dashSubtitle: "Utilizzo Agenti Studio · ultimi 30 giorni",
      dashSessions: "Sessioni",
      dashTokens: "Token totali",
      dashCostEst: "Costo stimato",
      dashTopAgent: "Agente top",
      dashByAgent: "Sessioni per agente",
      dashNoData: "Nessun dato ancora.",
      dashRecent: "Sessioni recenti",
      dashColDate: "Data",
      dashColAgent: "Agente",
      dashColModel: "Modello",
      dashColTokensOut: "Token out",
      dashColCost: "Costo",
      histOnly: "Cronologia disponibile solo nel piano Studio.",
      histTitle: "Cronologia Agenti Studio",
      histSubtitle: "Cerca e filtra le sessioni generate dagli agenti.",
      histAgent: "Agente",
      histAll: "Tutti",
      histFrom: "Da",
      histTo: "A",
      histSearch: "Cerca titolo",
      histKeyword: "Parola chiave…",
      histNone: "Nessuna sessione trovata.",
    },
    templates: {
      title: "Template",
      description: "Modelli pronti, preferiti, personali e cronologia documenti generati.",
      tabCatalog: "Catalogo ({{n}})",
      tabFavorites: "Preferiti ({{n}})",
      tabMine: "Miei ({{n}})",
      tabHistory: "Cronologia",
      catalog: "Catalogo",
      catalogTitle: "{{n}} template per ogni esigenza",
      catalogDesc: "Atti, contratti, pareri, diffide e altro. Compila i campi mancanti e l'AI rifinisce per te.",
      searchPh: "Cerca per nome, categoria o tag…",
      filterAll: "Tutti",
      noFavorites: "Nessun preferito ancora. Tocca la stella ⭐ in qualunque template del catalogo.",
      noMine: "Non hai ancora template personali. Compila un template del catalogo e salvalo.",
      noMatch: "Nessun template corrisponde alla ricerca.",
      noHistory: "Nessun documento generato finora.",
      personal: "Personale",
      open: "Apri",
      preview: "Anteprima",
      use: "Compila",
      close: "Chiudi",
      advanced: "Avanzato",
      basic: "Base",
      complexityAdvanced: "Avanzato",
      deleteTpl: "Eliminare il template?",
      deleted: "Eliminato",
      genericError: "Errore",
      colDoc: "Documento",
      colType: "Tipo",
      colUpdated: "Aggiornato",
      colActions: "Azioni",
      pdf: "PDF",
      docx: "DOCX",
      versions: "Versioni",
      versionsTitle: "Cronologia versioni",
      versionsDesc: "Ripristina una versione precedente del documento.",
      noVersions: "Nessuna versione salvata.",
      version: "Versione",
      restore: "Ripristina",
      restored: "Versione ripristinata",
    },
    generator: {
      title: "Genera documento",
      description: "Form guidato per tipologia e tono. La bozza si apre nell'editor.",
      stepType: "Tipologia",
      stepData: "Dati",
      stepTone: "Tono & contesto",
      back: "Indietro",
      continue: "Continua",
      backToType: "Tipologia",
      missingFields: "Compila: {{fields}}",
      generated: "Documento generato",
      toneCtxTitle: "Tono e contesto",
      toneCtxDesc: "Scegli il registro e collega opzionalmente la pratica.",
      tone: "Tono",
      linkedMatter: "Pratica collegata (opzionale)",
      noneOption: "- Nessuna -",
      attachContext: "Allega contesto dai documenti della pratica",
      attachContextDesc: "Userò i brani più rilevanti dei documenti indicizzati come fonte aggiuntiva (RAG).",
      generateDraft: "Genera bozza",
    },
    analysis: {
      title: "Analisi documenti",
      description: "Carica un PDF: clausole, parti, scadenze e rischi estratti dall'AI.",
      newBtn: "Nuovo",
      tooLarge: "File troppo grande (max 20MB).",
      pdfErrorPrefix: "Errore PDF: {{msg}}",
      analysisError: "Errore durante l'analisi",
      ocrError: "Errore OCR",
      scannedToast: "PDF scansionato: usa OCR per estrarre il testo.",
      drop: "Rilascia per analizzare",
      uploadPdf: "Carica un PDF",
      uploadDesc: "Trascina qui un PDF o clicca per selezionarlo. LexAIPro estrarrà clausole chiave, parti, scadenze, rischi e suggerimenti.",
      uploadHint: "Max 20MB · Anche PDF scansionati (OCR)",
      pages: "{{n}} pagine",
      pageN: "Pagina {{n}}",
      emptyPage: "Pagina vuota",
      analyzing: "Analisi in corso…",
      waiting: "In attesa dell'analisi…",
      tabSummary: "Sintesi",
      tabParties: "Parti",
      tabDates: "Date",
      tabClauses: "Clausole",
      tabRisks: "Rischi",
      suggestedActions: "Azioni consigliate",
      sevHigh: "Alto",
      sevMedium: "Medio",
      sevLow: "Basso",
      mitigation: "Mitigazione",
    },
    admin: {
      title: "Admin",
      description: "Gestione completa utenti, ruoli e contenuti della piattaforma.",
      fullAccess: "Accesso totale",
      automations: "Automazioni",
      errors: "Errori",
      modulesPlans: "Moduli & Piani",
      moduleSync: "Sync moduli",
      subscriptions: "Abbonamenti",
      support: "Supporto",
      webhooks: "Webhook",
      auditLog: "Audit log",
      adminBack: "← Admin",
      reload: "Ricarica",
      loading: "Caricamento…",
      noData: "Nessun dato",
      noEvents: "Nessun evento.",
      noUsers: "Nessun utente.",
      search: "Cerca…",
      actions: "Azioni",
      details: "Dettagli",
      retry: "Retry",
      retryScheduled: "Retry programmato",
      retryFailed: "Retry fallito",
      eventProcessed: "Evento elaborato",
      genericError: "Errore",
      loadError: "Errore caricamento",
      stats: {
        users: "Utenti",
        admins: "Admin",
        matters: "Pratiche",
        analyses: "Analisi",
        drafts: "Bozze",
      },
      tabs: {
        usersRoles: "Utenti & Ruoli",
        matters: "Pratiche",
        analyses: "Analisi",
        drafts: "Bozze",
      },
      registeredUsers: "Utenti registrati",
      cols: {
        user: "Utente",
        firm: "Studio",
        plan: "Piano",
        roles: "Ruoli",
        owner: "Owner",
        created: "Creato",
        when: "Quando",
        type: "Tipo",
        env: "Env",
        status: "Stato",
        attempts: "Tentativi",
        error: "Errore",
        next: "Prossimo",
        lastError: "Ultimo errore",
        sequence: "Sequenza",
        email: "Email",
        step: "Step",
        message: "Messaggio",
        route: "Route",
        level: "Liv.",
        source: "Sorgente",
        aiQuota: "Quota AI",
        limit: "Limite",
        lastPayment: "Ultimo pagamento",
        modules: "Moduli",
        cycle: "Ciclo",
        totalPerMonth: "Totale/mese",
      },
      removeRoleHint: "Clicca per rimuovere",
      addRole: "+ Ruolo",
      planSet: "Piano impostato a {{plan}}",
      roleAssigned: "Ruolo {{role}} assegnato",
      roleRemoved: "Ruolo {{role}} rimosso",
      deleteConfirm: "Eliminare definitivamente?",
      deleted: "Eliminato",
      audit: {
        title: "Audit log",
        description: "Tutte le azioni amministrative registrate.",
        empty: "Nessuna azione registrata.",
        actor: "Attore",
        target: "Target",
        ip: "IP",
        details: "Dettagli",
      },
      subs: {
        title: "Abbonamenti utenti",
        description: "Gestisci piano, limite e quota di tutti gli utenti.",
        planUpdated: "Piano aggiornato",
        limitUpdated: "Limite aggiornato",
        usageReset: "Utilizzo azzerato",
        resetQuota: "Reset quota",
      },
      automationsPage: {
        title: "Automazioni Email",
        description: "Stato delle sequenze drip, retry automatici e dead-letter queue.",
        runNow: "Esegui ora",
        runDone: "Eseguito: {{n}} processati",
        active: "Attive",
        completed: "Completate",
        failed24h: "Falliti 24h",
        deadLetter: "Dead letter",
        all: "Tutti",
        stopped: "Fermate",
        dlq: "Dead-letter",
        update: "Aggiorna",
        noRuns: "Nessun run.",
      },
      errorsPage: {
        title: "Errori & diagnostica",
        description: "Tracciamento centralizzato di errori applicativi, eventi quota e crash.",
        events24h: "Eventi 24h",
        events7d: "Eventi 7g",
        usersImpacted: "Utenti impattati 7g",
        quotaExhausted: "Quota esaurita 24h",
        trend14d: "Andamento ultimi 14 giorni",
        topMessages: "Top messaggi (7g)",
        noErrors: "Nessun errore.",
        recent: "Eventi recenti",
        allLevels: "Tutti",
        allSources: "Tutte le sorgenti",
        exportCsv: "CSV",
      },
      modulesPage: {
        title: "Admin · Moduli & Piani",
        description: "Attiva/disattiva moduli, cambia piano e ricicla prezzi per qualsiasi utente.",
        auditSync: "Audit sync",
        users: "Utenti",
        searchPh: "Cerca email/nome…",
        edit: "Modifica",
        editTitle: "Modifica moduli — {{email}}",
        plan: "Piano",
        cycle: "Ciclo",
        cycleMonthly: "Mensile",
        cycleAnnual: "Annuale (−20%)",
        activeModules: "Moduli attivi",
        computedTotal: "Totale calcolato",
        serverTotal: "Totale server (verifica)",
        bundleSummary: "{{n}} moduli · sconto bundle {{bundle}}% · sconto annuale {{cycle}}%",
        recomputeServer: "Ricalcola lato server",
        save: "Salva modifiche",
        saving: "Salvataggio…",
        recomputed: "Totale ricalcolato: €{{total}}/mese",
        recomputeError: "Errore ricalcolo",
        saveError: "Errore salvataggio",
        updated: "Aggiornato",
      },
      moduleSyncPage: {
        title: "Audit · Module Subs Sync",
        description: "Eventi webhook recenti, errori di sincronizzazione moduli, stato sottoscrizioni.",
        autoRefresh: "Auto-refresh",
        on: "ON",
        off: "OFF",
        updatedAt: "Aggiornato: {{time}}",
        backModules: "← Moduli",
        webhookEvents: "Eventi webhook",
        failedEvents: "Eventi falliti",
        activeSubs: "Sub. attive",
        canceledSubs: "Sub. cancellate",
        recentWebhooks: "Eventi webhook recenti",
        syncErrors: "Errori sync moduli (error_logs)",
        recentSubs: "Module subscriptions recenti",
        noErrors: "Nessun errore registrato.",
        noSubs: "Nessuna sottoscrizione moduli.",
        user: "User",
        module: "Modulo",
        expiry: "Scadenza",
      },
      supportPage: {
        title: "Supporto — Ticket",
        description: "Gestione ticket di tutti gli utenti.",
        totalTickets: "{{n}} totali",
        ticketsTitle: "Ticket",
        all: "Tutti",
        open: "Aperti",
        answered: "Risposti",
        resolved: "Risolti",
        closed: "Chiusi",
        noTickets: "Nessun ticket.",
        userPrefix: "utente",
        replyPh: "Risposta del supporto…",
        send: "Invia",
        replySent: "Risposta inviata",
        statusUpdated: "Stato aggiornato",
        backToList: "Torna alla lista",
        statusOpen: "Aperto",
        statusAnswered: "Risposto",
        statusResolved: "Risolto",
        statusClosed: "Chiuso",
        meSupport: "Tu (Supporto)",
        bot: "Assistente",
        userRole: "Utente",
        ticketHeader: "Utente {{user}} · Aperto {{date}}",
      },
      webhooksPage: {
        title: "Webhook Paddle",
        description: "Audit log degli eventi ricevuti, stato, payload e retry manuale.",
        totalEvents: "Eventi totali",
        processed: "Processati",
        processing: "In elaborazione",
        failed: "Falliti",
        events: "Eventi",
        searchPh: "event_id, errore, tipo…",
        allEnv: "Tutti env",
        allStatus: "Tutti stati",
        retryManual: "Riprova manualmente",
        eventProcessed: "Evento elaborato",
        retryFailedReason: "Retry fallito: {{reason}}",
        envBadge: "env: {{env}}",
        statusBadge: "stato: {{status}}",
        attemptsBadge: "tentativi: {{n}}",
      },
    },
    supporto: {
      title: "Supporto",
      description: "Trova risposte istantanee con il chatbot, consulta le FAQ o apri un ticket.",
      tabChatbot: "Chatbot",
      tabFaq: "FAQ",
      tabMyTickets: "I miei ticket",
      tabNew: "Apri ticket",
      assistantTitle: "Assistente di supporto",
      assistantHello: "Ciao! Sono l'assistente di supporto di LexAIPro. Come posso aiutarti?",
      thinking: "Sto pensando…",
      askPh: "Scrivi la tua domanda…",
      sendError: "Errore",
      assistantFallback: "Mi dispiace, non riesco a rispondere ora. Prova ad aprire un ticket.",
      loading: "Caricamento…",
      noTickets: "Nessun ticket. Aprine uno dalla scheda \"Apri ticket\".",
      newReply: "Nuova risposta ricevuta",
      backToTickets: "Torna ai ticket",
      replyPh: "Scrivi la tua risposta…",
      sendReply: "Invia risposta",
      newTicket: "Apri un nuovo ticket",
      subject: "Oggetto",
      subjectPh: "Riassunto del problema",
      category: "Categoria",
      priority: "Priorità",
      description2: "Descrizione",
      bodyPh: "Descrivi nel dettaglio il problema o la richiesta…",
      sendTicket: "Invia ticket",
      ticketCreated: "Ticket aperto. Il supporto risponderà al più presto.",
      paymentNotice: "Per problemi di pagamento gravi contatta direttamente",
      billingLink: "Fatturazione",
      catBilling: "Fatturazione",
      catTechnical: "Tecnico",
      catFeature: "Richiesta funzionalità",
      catAccount: "Account",
      catOther: "Altro",
      prioLow: "Bassa",
      prioNormal: "Normale",
      prioHigh: "Alta",
      roleSupport: "Supporto",
      roleBot: "Assistente",
      roleYou: "Tu",
      faq: [
        { q: "Come cambio piano?", a: "Vai in **Account → Fatturazione** e scegli il piano desiderato. Il cambio è immediato." },
        { q: "Cosa sono gli Agenti Studio?", a: "10 agenti AI specializzati per attività ricorrenti (Due Diligence, KYC, GDPR, ecc.). Esclusivi del piano Studio." },
        { q: "Quale modello AI uso?", a: "Starter: Gemini Flash. Pro: GPT-5 mini. Studio: GPT-5.2 + Claude Sonnet 4.5." },
        { q: "I miei documenti sono al sicuro?", a: "Sì: crittografati at-rest e in transito, isolati per utente, conformi GDPR." },
        { q: "Come esporto la cronologia?", a: "Da **Cronologia** seleziona la conversazione e usa l'azione di esportazione (in arrivo)." },
        { q: "Quante query AI ho?", a: "Starter 100/mese, Pro 1.000/mese, Studio 10.000/mese. Vedi il contatore in Dashboard." },
      ],
    },
  },
  mobile: {
    nav: {
      home: "Home",
      research: "Ricerca",
      documents: "Documenti",
      drafting: "Redazione",
      more: "Altro",
    },
    drawer: {
      title: "Tutto",
      sections: {
        practice: "Pratica",
        tools: "Strumenti",
        productivity: "Produttività",
        account: "Account",
        admin: "Admin",
      },
      logout: "Esci",
      language: "Lingua",
    },
    actions: {
      back: "Indietro",
      close: "Chiudi",
      menu: "Menu",
    },
  },
  common: {
    save: "Salva",
    cancel: "Annulla",
    confirm: "Conferma",
    delete: "Elimina",
    edit: "Modifica",
    search: "Cerca",
    back: "Indietro",
    next: "Avanti",
    close: "Chiudi",
    open: "Apri",
    loading: "Caricamento…",
    retry: "Riprova",
    error: "Errore",
    success: "Operazione riuscita",
    yes: "Sì",
    no: "No",
    or: "oppure",
    more: "Altro",
    new: "Nuovo",
    add: "Aggiungi",
    send: "Invia",
    create: "Crea",
    update: "Aggiorna",
    sendingRequestTooLong: "La richiesta ha impiegato troppo tempo. Riprova.",
    networkError: "Errore di rete",
    requestCancelled: "Richiesta annullata",
  },
  accountMenu: {
    label: "Account",
    admin: "Admin",
    logout: "Esci",
  },
  upgradeWall: {
    title: "Funzione esclusiva del piano Studio",
    description: "Sblocca Claude Sonnet 4.5, GPT-5.2, i 10 Agenti Studio e il cruscotto avanzato.",
    feat1: "Claude Sonnet 4.5",
    feat2: "GPT-5.2 illimitato",
    feat3: "10 Agenti Studio specializzati",
    cta: "Passa a Studio",
    later: "Continua col mio piano",
  },
  mobileHome: {
    title: "Come posso aiutarti?",
    subtitle: "Scegli un'area e scrivi la domanda.",
    areaCivil: "Civile",
    areaLabor: "Lavoro",
    areaCorporate: "Societario",
    areaPrivacy: "Privacy",
    areaBanking: "Bancario e Assicurativo",
    areaFamily: "Famiglia",
    areaTax: "Tributario",
    areaIp: "Proprietà Intellettuale",
    areaAdmin: "Amministrativo",
    areaCriminal: "Penale",
    areaConsumer: "Diritto dei Consumatori",
    areaRealEstate: "Real Estate",
    areaCrisis: "Crisi d'Impresa",
    areaCompliance: "Compliance",
    areaSchool: "Diritto Scolastico",
    moreAreas: "Altre aree…",
    chooseArea: "Scegli un'area",
    modeAsk: "Chiedi",
    modeDraft: "Redazione",
    modeCompare: "Confronto",
    inputPlaceholder: "Scrivi la tua domanda…",
    attach: "Allega documento",
    dictate: "Detta",
    send: "Invia",
    cancel: "Annulla",
    remove: "Rimuovi",
  },
  drafting: {
    pageTitle: "Redazione assistita",
    pageDescription: "Atti giudiziari, contratti, pareri.",
    newDraft: "Nuova bozza",
    drafts: "Bozze",
    noDrafts: "Nessuna bozza.",
    titlePlaceholderFull: "Titolo della bozza",
    titlePlaceholder: "Titolo",
    save: "Salva",
    more: "Altro",
    preview: "Anteprima",
    edit: "Modifica",
    exportDocx: "Esporta DOCX",
    exportPdf: "Esporta PDF",
    docx: "DOCX",
    pdf: "PDF",
    revise: "Revisiona",
    revisePresets: {
      clarity: "Migliora chiarezza",
      formal: "Tono più formale",
      shorten: "Sintetizza",
      expand: "Espandi argomentazione",
      grammar: "Correggi grammatica",
    },
    customInstructionPrompt: "Istruzione personalizzata:",
    customInstruction: "Istruzione personalizzata…",
    startTitle: "Inizia a redigere",
    startDesc: "Crea una nuova bozza o seleziona una esistente.",
    emptyDoc: "Bozza vuota",
    nothingToContinue: "Scrivi qualcosa prima di chiedere all'AI di continuare.",
    openEditorFirst: "Apri l'editor prima di revisionare.",
    selectOrWrite: "Seleziona del testo o scrivi qualcosa.",
    revised: "Testo revisionato",
    aiError: "Errore AI",
    reviseError: "Errore revisione",
    pdfGenerated: "PDF generato",
    docxGenerated: "DOCX generato",
    exportFailed: "Export fallito",
    exportPdfError: "Errore durante l'export PDF",
    exportDocxError: "Errore durante l'export DOCX",
    saving: "Salvataggio…",
    saved: "Salvato",
    savingError: "Errore",
  },
  chat: {
    headerFallback: "Conversazione",
    newChat: "Nuova chat",
    notAvailable: "Conversazione non disponibile",
    notAvailableHint: "Potrebbe essere stata eliminata o non hai i permessi per visualizzarla.",
    backHome: "Torna alla home",
    noMessages: "Nessun messaggio.",
    question: "Domanda",
    answer: "Risposta",
    thinking: "Sto pensando",
    placeholder: "Continua la conversazione…",
    send: "Chiedi",
    sending: "Invio…",
    attach: "Allega documento",
    dictate: "Detta",
    remove: "Rimuovi {{name}}",
    filesPending: "{{n}} file in attesa",
    fReady: "Pronto",
    fUploading: "Caricamento…",
    fError: "Errore",
    mPages: "Pagine",
    mAlerts: "Alert",
    mConfidence: "Confidenza",
    loadError: "Errore nel caricamento",
    error: "Errore",
    networkError: "Errore di rete",
    verified: "Verificato",
  },
  auth: {
    signupTitle: "Crea il tuo account",
    signupSubtitle: "Inizia con LexAIPro gratuitamente",
    loginTitle: "Bentornato",
    loginSubtitle: "Accedi al tuo account LexAIPro",
    fullName: "Nome completo",
    email: "Email",
    password: "Password",
    create: "Crea account",
    creating: "Creazione...",
    signIn: "Accedi",
    signingIn: "Accesso...",
    or: "oppure",
    continueGoogle: "Continua con Google",
    signupGoogle: "Registrati con Google",
    continueApple: "Continua con Apple",
    signupApple: "Registrati con Apple",
    redirecting: "Reindirizzamento...",
    haveAccount: "Hai già un account?",
    noAccount: "Non hai un account?",
    register: "Registrati",
    accountCreated: "Account creato!",
    signedIn: "Accesso effettuato",
    googleError: "Errore accesso con Google",
    appleError: "Errore accesso con Apple",
    googleSignupError: "Errore registrazione con Google",
    appleSignupError: "Errore registrazione con Apple",
    signupInProgress: "Registrazione in corso…",
    signinInProgress: "Accesso in corso…",
    seoSignupTitle: "Inizia gratis - LexAIPro",
    seoSignupDesc: "Crea il tuo account LexAIPro: 14 giorni di prova gratuita, senza carta di credito.",
    seoLoginTitle: "Accedi - LexAIPro",
    seoLoginDesc: "Accedi al tuo account LexAIPro per usare ricerca legale, analisi documenti e redazione AI.",
  },
  onboarding: {
    steps: { profile: "Profilo", firm: "Studio", areas: "Specializzazioni", ready: "Pronto" },
    areas: {
      civil: "Civile", commercial: "Commerciale", labor: "Lavoro", criminal: "Penale",
      tax: "Tributario", family: "Famiglia", admin: "Amministrativo", immigration: "Immigrazione",
      ip: "Proprietà intellettuale", privacy: "Privacy & GDPR",
    },
    step0Title: "Iniziamo dalle basi",
    step0Desc: "Come ti chiami?",
    fName: "Nome",
    fLastName: "Cognome",
    step1Title: "Il tuo studio",
    step1Desc: "Iscrizione all'Ordine.",
    fFirm: "Nome studio",
    fBarOrder: "Ordine di",
    fBarOrderPh: "Milano",
    fBarNumber: "Numero iscrizione",
    step2Title: "Le tue specializzazioni",
    step2Desc: "Selezionane almeno una.",
    step3Title: "Tutto pronto, {{name}}!",
    step3Default: "avvocato",
    step3Desc: "Inizia a esplorare LexAIPro con 100 query AI gratuite.",
    welcome: "Benvenuto in LexAIPro!",
    back: "Indietro",
    next: "Avanti",
    enter: "Entra in LexAIPro",
  },
  quotaDialog: {
    title: "Crediti AI esauriti",
    descUsage: "Hai utilizzato <strong>{{used}}/{{limit}}</strong> query AI del tuo piano.",
    descPlain: "Hai esaurito le query AI del tuo piano.",
    upgradeHint: "Aggiorna il piano per continuare a usare la ricerca legale assistita.",
    close: "Chiudi",
    upgrade: "Aggiorna piano",
  },
  scannedPdf: {
    title: "Sembra un PDF scansionato",
    desc: "Non riusciamo a estrarre il testo: le {{n}} pagine sono immagini. Scegli come procedere.",
    ocrText: "OCR testo",
    ocrTextLimit: "(max 20 pagine)",
    ocrTables: "OCR + tabelle",
    pasteText: "Incolla testo",
    reupload: "Carica un altro file",
    pastePlaceholder: "Incolla qui il testo del documento…",
    analyze: "Analizza testo",
  },
  wordBanner: {
    close: "Chiudi",
    title: "Usa LexAI in Word",
    subtitle: "Il tuo flusso di lavoro, senza interruzioni.",
    install: "Installa l'Add-in",
  },
};

